
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artikel/[slug]",
      function () {
        return require("private-next-pages/artikel/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artikel/[slug]"])
      });
    }
  